module.exports = __webpack_public_path__ + "img/Rice-data-logo.d2e85e74.png";